import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ResponseBase } from '../models/response-base';
import { Observable } from 'rxjs';
import { Feriado } from '../models/feriado';

@Injectable({
  providedIn: 'root'
})
export class FeriadoService {

  API: string = environment.API + 'Portal/feriados';

  constructor(private http: HttpClient) { }


  getAll(): Observable<ResponseBase<Feriado[]>> {
    return this.http.get<ResponseBase<Feriado[]>>(`${this.API}`);
  }
}
